import { AxiosResponse } from "axios";
import { getFormData, RestClient } from "../RestClient";

export type B110040Request = {
  excelFileData: File;
};

export type B110040Response = {
  torikomikeka: string;
};

// 担当者別目標データ EXCEL 取込
export const B110040Import = (
  props: B110040Request
): Promise<AxiosResponse<B110040Response>> => {
  return RestClient.post("b110040/import", getFormData(props));
};
